export default __webpack_public_path__ + "static/media/drum_one.f1af0353.mp3";